<script lang="ts">
  import UIDisclaimer from '$provider/constants/UIDisclaimer';
  import AttachmentWarnAlert from './AttachmentWarnAlert.svelte';
</script>

<AttachmentWarnAlert>
  {UIDisclaimer.LicenseUnsupportedAttachment}
</AttachmentWarnAlert>
